import React from 'react';

import Heading from '@marvelapp/marvel-ui/heading';
import Spacing from '@marvelapp/marvel-ui/spacing';
import styles from './h.module.css';

/* eslint-disable react/prop-types */
const h = ({ tag, size, position, spacing }) => props => (
  <Spacing type="padding" position={position} size={spacing}>
    <div
      className={styles.anchorOffsetForFixedHeader}
      id={convertToIdName(props.children[0])}
    >
      <Heading tag={tag} size={size} weight="semibold">
        {props.children}
      </Heading>
    </div>
  </Spacing>
);

function convertToIdName(string) {
  const alphanumberic = string.replace(/[^\w\s]/gi, '');
  return alphanumberic.replace(/ /g, '-').toLowerCase();
}

export default h;



// WEBPACK FOOTER //
// ./src/components/markdown/h.js